var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPivotSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:#475164;}.d{fill:#465165;}.e{clip-path:url(#b);}.f{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M483.2,489.6c3.2,0,6.1,1.2,7.5,3l116.2,98.8c2.7,3.6-1.3,7.7-7.5,7.7H2.2c-6.2,0-10.2-4.2-7.5-7.7l116.2-98.8c1.4-1.8,4.3-3,7.5-3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "225.8 599.1 293.1 599.1 293.1 489.6 256 489.6 225.8 599.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "163.6 489.6 64.6 599.1 128.5 599.1 192.6 489.6 163.6 489.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "354.3 489.6 389.1 599.1 456.5 599.1 391.5 489.6 354.3 489.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M599.4,599.1c6.2,0,10.2-4.2,7.5-7.7l-116.2-98.8c-1.4-1.8-4.3-3-7.5-3h-28l99.2,109.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "406.8 489.6 472.6 599.8 473.1 600 537.9 599.1 438.5 490.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M118.4,489.6c-3.2,0-6.1,1.2-7.5,3L-5.3,591.4c-2.7,3.6,1.3,7.7,7.5,7.7H46.8l99-109.5h-27.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "306.3 489.6 306.3 599.1 375.3 599.1 340.5 489.6 306.3 489.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "207.8 489.6 143.8 599.1 212.2 599.1 242.4 489.6 207.8 489.6"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 253.6,
    y: 386.7,
    width: 26.4,
    height: 73.4,
    rx: 3.5,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 321.4,
    y: 386.7,
    width: 26.4,
    height: 73.4,
    rx: 3.5,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M596.9,213.5c-.8-.5-15.3-8.7-40.3-17v-6.7c0-1.1-.7-2-1.6-2h-2.7c-.9,0-1.6,.9-1.6,2v4.8c-7.5-2.3-15.8-4.6-24.9-6.7-12.2-2.8-24.6-4.9-37.1-6.2v-5.8c0-1.1-.7-2-1.6-2h-2.7c-.9,0-1.6,.9-1.6,2v5.2c-10.5-1-21-1.5-31.6-1.5s-3.5,0-5.3,0c-8.4,.1-16.5,.6-24.4,1.2v-4.2c0-1.1-.7-2-1.6-2h-2.7c-.9,0-1.6,.9-1.6,2v4.8c-24.2,2.5-45.3,7.4-62.3,12.5v-4.8c0-1.1-.7-2-1.6-2h-2.7c-.9,0-1.6,.9-1.6,2v6.7c-24.1,7.8-39,15.9-41.9,17.6,0,0,0,0,0,0v-15.2h-11.1v13.3c-5.7-3-18.4-9.1-36.9-15.2v-6.7c0-1.1-.7-2-1.6-2h-2.7c-.9,0-1.6,.9-1.6,2v4.8c-7.5-2.3-15.8-4.6-24.9-6.6-12.2-2.8-24.6-4.9-37.1-6.2v-5.8c0-1.1-.7-2-1.6-2h-2.7c-.9,0-1.6,.9-1.6,2v5.2c-10.5-1-21-1.5-31.6-1.5s-3.5,0-5.3,0c-8.4,.1-16.5,.6-24.4,1.2v-4.2c0-1.1-.7-2-1.6-2h-2.7c-.9,0-1.6,.9-1.6,2v4.8c-24.2,2.5-45.3,7.4-62.3,12.5v-4.8c0-1.1-.7-2-1.6-2h-2.7c-.9,0-1.6,.9-1.6,2v6.7c-24.1,7.8-39,15.9-41.9,17.6,0,0,0,0-.1,0-1.5,.9-2.4,2.5-2.4,4.3,0,1.8,.9,3.4,2.4,4.3,0,0,0,0,.1,0,5.9,3.3,59.7,32.5,140.3,33.8,1.8,0,3.5,0,5.3,0,25.1,0,50.2-2.8,74.6-8.3,8.2-1.9,15.8-3.9,22.8-6h0c8.1-2.4,15.2-4.9,21.4-7.3l1,.9-.4-1.2c11-4.2,18.8-8,22.9-10.2v189.3c-1.5,1.1-2.6,2.7-3.3,4.6h-10.8v11.3h13.9s0,0,0,0v9.5h11.1v-9.6h16.1v-11.3h-12.9c-.6-1.8-1.7-3.4-3.1-4.5V222.1s0,0,0,0c5.9,3.3,59.7,32.5,140.3,33.8,1.8,0,3.5,0,5.3,0,25.1,0,50.2-2.8,74.6-8.3,8.2-1.9,15.8-3.9,22.8-6h0c8.1-2.4,15.2-4.9,21.4-7.3l1,.9-.4-1.2c16.4-6.3,25.7-11.6,26.3-12,1.5-.9,2.5-2.5,2.5-4.3s-.9-3.4-2.5-4.3Zm-341-7c2.1,.7,4,1.4,5.9,2.1l1.9,6.4c-4.6-.5-9.2-1-14-1.5l-.5-.5,6.7-6.6Zm-1.9-.6l-7.4,7.3h.2c-1.3,0-2.7,0-4-.2l-2.6-11.3c4.9,1.4,9.5,2.8,13.8,4.2Zm-16.1-4.8l2.7,11.7c-4.5-.3-9.1-.7-13.7-.9l8.8-11.4c.7,.2,1.5,.4,2.2,.6Zm-13.6-3.4c3.2,.7,6.2,1.5,9.2,2.2l-9.1,11.8c-1.2,0-2.5-.1-3.7-.2l-4-15.5c2.5,.5,5.1,1,7.6,1.6Zm-10.5-2.2l4.1,15.9c-6.1-.3-12.4-.5-18.6-.7l13.3-15.5c.4,0,.8,.1,1.2,.2Zm-4.2-.8l-13.8,16c-1.3,0-2.5,0-3.8,0l-4.5-19.1c7.4,.8,14.7,1.9,22,3.2Zm-24.1-.2l3.8,16c-5.5,0-10.9-.1-16.4-.1l12.6-15.9Zm-.8-3.3l-15.3,19.2c-1.9,0-3.7,0-5.6,0l-4.7-20.8c8.5,.2,17.1,.7,25.6,1.6Zm-23.7,19.2c-5.3,0-10.5,.1-15.7,.2l12.1-16,3.5,15.7Zm-14.2-20.8h.1c1.6,0,3.3,0,5,0s3.9,0,5.9,0l-16.1,21.1c-1.9,0-3.9,0-5.8,.1l-4.7-20.7c5-.3,10.2-.5,15.5-.6Zm-13.7,21.4c-5.6,.2-11.1,.3-16.5,.6l12.8-16.8,3.7,16.3Zm-3.9-20.6l-16.2,21.3c-1.6,0-3.3,.1-4.9,.2l-4.2-18.8c8-1.2,16.5-2.1,25.3-2.7Zm-23.9,21.6c-6.1,.3-12,.6-17.7,.9l13.8-18.2,3.9,17.3Zm-6.8-18l-14.6,19.1c-2.8,.2-5.5,.3-8.2,.5l-3.7-14.1c8.2-2.1,17-3.9,26.5-5.5Zm-29,6.2l3.6,13.6c-6.4,.4-12.4,.8-18,1.2l-.7-.7,11.9-13.4c1-.3,2.1-.5,3.1-.8Zm-7.7,2.1l-10.9,12.2,.8,.8c-2.5,.2-4.8,.4-7.1,.5l-2.5-7.2c5.8-2.1,12.4-4.3,19.7-6.4Zm-21.4,7l2.4,6.7c-5.3,.4-10,.8-14,1.2l7.4-6.3c1.4-.5,2.8-1.1,4.2-1.6Zm-20.7,8.6c3-1.4,6.7-3.1,11.1-4.9l-5.2,4.4c-2.1,.2-4,.4-5.6,.5,0,0-.1,0-.2,0Zm5.3,2.4c.8,0,1.7-.2,2.6-.2l4,3c-2.4-1-4.6-1.9-6.6-2.8Zm13,5.3l-7.6-5.8c3.9-.3,8.4-.7,13.3-1.1l3.6,10.2c-3.3-1.1-6.4-2.2-9.3-3.3Zm11.5,4.1l-3.9-11.1c2.8-.2,5.7-.4,8.7-.7l18.4,18.5c-8.5-2.1-16.3-4.4-23.3-6.7Zm28.1,7.9l-19.8-19.9c5.1-.4,10.4-.7,16.1-1.1l5.7,21.4c-.7-.2-1.3-.3-2-.5Zm4.8,1.1l-5.9-22.2c2.8-.2,5.8-.3,8.7-.5l23.2,27.3c-9.2-1.2-17.9-2.8-26-4.6Zm6.4-22.9c5.6-.3,11.3-.6,17.2-.9l6.5,28.9-23.8-28Zm26.7,28.4l-6.6-29.4c1.1,0,2.2,0,3.3-.1l26.5,31.3c-8-.3-15.8-.9-23.2-1.8Zm.2-29.6c5.9-.2,12-.4,18.1-.6l6.7,29.9-24.8-29.3Zm36.3,31.7c-1.7,0-3.4,0-5,0h-.1c-1,0-1.9,0-2.9,0l-7.3-32.3c1,0,2,0,3,0v.2l27,32c-4.9,.2-9.8,.3-14.7,.3Zm-8.9-32.4h.1c6.1-.3,12.3-.4,18.5-.4l6.9,30.4-25.4-30Zm28.7,31.8l-7.3-32.2c1.2,0,2.4,0,3.7,0l26.6,30.1c-7.7,1-15.3,1.7-23,2.2Zm0-32.3c6.1,0,12.1,0,18.2,.1l6.5,27.8-24.8-27.9Zm27.9,29.4l-6.9-29.2c1.7,0,3.3,0,5,.1l24.1,25c-7.3,1.6-14.7,2.9-22.2,4Zm1.8-29c5.7,.2,11.5,.4,17.1,.6l6,23.4-23.1-24Zm25.8,23.7l-5.9-23c1.5,0,3.1,.2,4.6,.2l16.2,18.8c-4.7,1.3-9.7,2.7-14.9,3.9Zm17.1-4.5l-15.5-18c4.2,.3,8.3,.5,12.4,.9l3.9,16.9c-.3,0-.5,.2-.8,.2Zm2.7-.8l-3.7-16.2c2.3,.2,4.6,.4,6.9,.6l11.9,10.5c-4.6,1.7-9.7,3.4-15.1,5.1Zm17.1-5.8l-10.8-9.5c3.8,.4,7.6,.8,11.3,1.2l2.2,7.3c-.9,.3-1.8,.7-2.7,1Zm4.4-1.7l-1.9-6.4c4.4,.6,8.7,1.2,12.8,1.8-3.1,1.4-6.8,2.9-10.9,4.5Zm15.5-6.6c-5.9-1-12-1.9-18.3-2.7l-1.8-5.9c8.6,3.2,15.4,6.2,20.3,8.5,0,0-.2,0-.2,.1Zm271.1-11.4c2.1,.7,4,1.4,5.9,2.1l1.9,6.4c-4.6-.5-9.2-1-14-1.5l-.5-.5,6.7-6.6Zm-1.9-.6l-7.4,7.3h.2c-1.3,0-2.7,0-4-.2l-2.6-11.3c4.9,1.4,9.5,2.8,13.8,4.2Zm-16.1-4.8l2.7,11.7c-4.5-.3-9.1-.7-13.7-.9l8.8-11.4c.7,.2,1.5,.4,2.2,.6Zm-13.6-3.4c3.2,.7,6.2,1.5,9.2,2.2l-9.1,11.8c-1.2,0-2.5-.1-3.7-.2l-4-15.5c2.5,.5,5.1,1,7.6,1.6Zm-10.5-2.2l4.1,15.9c-6.1-.3-12.4-.5-18.6-.7l13.3-15.5c.4,0,.8,.1,1.2,.2Zm-4.2-.8l-13.8,16c-1.3,0-2.5,0-3.8,0l-4.5-19.1c7.4,.8,14.7,1.9,22,3.2Zm-24.1-.2l3.8,16c-5.5,0-10.9-.1-16.4-.1l12.6-15.9Zm-.8-3.3l-15.2,19.2c-1.9,0-3.7,0-5.6,0l-4.7-20.8c8.5,.2,17.1,.7,25.6,1.6Zm-23.7,19.2c-5.3,0-10.5,.1-15.7,.2l12.1-16,3.5,15.7Zm-14.2-20.8h.1c1.6,0,3.3,0,5,0s3.9,0,5.9,0l-16.1,21.1c-1.9,0-3.9,0-5.8,.1l-4.7-20.7c5-.3,10.2-.5,15.5-.6Zm-13.7,21.4c-5.6,.2-11.1,.3-16.5,.6l12.8-16.8,3.7,16.3Zm-3.9-20.6l-16.2,21.3c-1.6,0-3.3,.1-4.9,.2l-4.2-18.8c8-1.2,16.5-2.1,25.3-2.7Zm-23.9,21.6c-6.1,.3-12,.6-17.7,.9l13.8-18.2,3.9,17.3Zm-6.8-18l-14.6,19.1c-2.8,.2-5.5,.3-8.2,.5l-3.7-14.1c8.2-2.1,17-3.9,26.5-5.5Zm-29,6.2l3.6,13.6c-6.4,.4-12.4,.8-18,1.2l-.7-.7,11.9-13.4c1-.3,2.1-.5,3.1-.8Zm-7.7,2.1l-10.9,12.2,.8,.8c-2.5,.2-4.8,.4-7.1,.5l-2.5-7.2c5.8-2.1,12.4-4.3,19.7-6.4Zm-21.4,7l2.4,6.7c-5.3,.4-10,.8-14,1.2l7.4-6.3c1.4-.5,2.8-1.1,4.2-1.6Zm-20.7,8.6c3-1.4,6.7-3.1,11.1-4.9l-5.2,4.4c-2.1,.2-4,.4-5.6,.5,0,0-.1,0-.2,0Zm5.3,2.4c.8,0,1.7-.2,2.6-.2l4,3c-2.4-1-4.6-1.9-6.7-2.8Zm13,5.3l-7.6-5.8c3.9-.3,8.4-.7,13.3-1.1l3.6,10.2c-3.3-1.1-6.4-2.2-9.3-3.3Zm11.5,4.1l-3.9-11.1c2.8-.2,5.7-.4,8.7-.7l18.4,18.5c-8.5-2.1-16.3-4.4-23.3-6.7Zm28.1,7.9l-19.8-19.9c5.1-.4,10.4-.7,16.1-1.1l5.7,21.4c-.7-.2-1.3-.3-2-.5Zm4.8,1.1l-5.9-22.2c2.8-.2,5.8-.3,8.7-.5l23.2,27.3c-9.2-1.2-17.9-2.8-26-4.6Zm6.4-22.9c5.6-.3,11.3-.6,17.2-.9l6.5,28.9-23.8-28Zm26.7,28.4l-6.6-29.4c1.1,0,2.2,0,3.3-.1l26.5,31.3c-8-.3-15.8-.9-23.2-1.8Zm.2-29.6c5.9-.2,12-.4,18.1-.6l6.7,29.9-24.8-29.3Zm36.3,31.7c-1.7,0-3.4,0-5,0h-.1c-1,0-1.9,0-2.9,0l-7.3-32.3c1,0,2,0,3,0v.2l27,32c-4.9,.2-9.8,.3-14.7,.3Zm-8.9-32.4h.1c6.1-.3,12.3-.4,18.5-.4l6.9,30.4-25.4-30Zm28.7,31.8l-7.3-32.2c1.2,0,2.4,0,3.7,0l26.6,30c-7.7,1-15.3,1.7-23,2.2Zm0-32.3c6.1,0,12.1,0,18.2,.1l6.5,27.8-24.8-27.9Zm27.9,29.4l-6.9-29.2c1.7,0,3.3,0,5,.1l24.1,25c-7.3,1.6-14.7,2.9-22.2,4Zm1.8-29c5.7,.2,11.5,.4,17.1,.6l6,23.4-23.1-24Zm25.8,23.7l-5.9-23c1.5,0,3.1,.2,4.6,.2l16.2,18.8c-4.7,1.3-9.7,2.7-14.9,3.9Zm17.1-4.5l-15.5-18c4.2,.3,8.3,.5,12.4,.9l3.9,16.9c-.3,0-.5,.2-.8,.2Zm2.7-.8l-3.7-16.2c2.3,.2,4.6,.4,6.9,.6l11.9,10.5c-4.6,1.7-9.7,3.4-15.1,5.1Zm17.1-5.8l-10.8-9.5c3.8,.4,7.6,.8,11.3,1.2l2.2,7.3c-.9,.3-1.8,.7-2.7,1Zm4.4-1.7l-1.9-6.4c4.4,.6,8.7,1.2,12.8,1.8-3.1,1.4-6.8,2.9-10.9,4.5Zm15.5-6.6c-5.9-1-12-1.9-18.3-2.7l-1.8-5.9c8.6,3.2,15.4,6.2,20.3,8.5,0,0-.2,0-.2,.1Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M57.7,160.1l-1.7-.6c-.4,1-.7,1.9-1,2.9l1.7,.5c.3-.9,.6-1.9,1-2.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M59.9,154.6l-1.6-.7c-.4,.9-.8,1.9-1.2,2.8l1.7,.7c.4-.9,.7-1.8,1.2-2.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M54.5,171.5l-1.8-.4c-.2,1.1-.4,2.1-.6,3l1.8,.3c.1-.9,.3-1.9,.5-2.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M55.9,165.7l-1.7-.5c-.3,1-.5,2-.8,2.9l1.8,.4c.2-.9,.5-1.9,.8-2.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M65.9,140.7l1.5,1.1c.6-.8,1.2-1.6,1.8-2.3l-1.4-1.1c-.6,.8-1.3,1.6-1.9,2.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M62.6,149.2l-1.6-.9c-.5,.9-1,1.8-1.4,2.7l1.6,.8c.4-.9,.9-1.8,1.4-2.6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.6,177.4l-1.4-.2c0-.3,0-1.3,0-2.9h-1c0-.4,0-.7-.2-1l-1.8,.3c.2,1,.3,1.9,.5,2.9h.6c0,.5,0,.8,0,.8h1.4c-.1,.9-.2,1.5-.2,2l-1.4,.2c0,.5,.1,1,.2,1.5l1.8-.2c0-.2,0-.4,0-.6h1.2s0-1,.3-2.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M65.6,144.2l-1.5-1c-.6,.9-1.1,1.7-1.6,2.6l1.5,.9c.5-.8,1-1.7,1.6-2.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M82.1,127.4l-1-1.5c-.8,.6-1.7,1.2-2.5,1.8l1.1,1.4c.8-.6,1.6-1.2,2.4-1.7Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M87.2,124.4l-.9-1.6c-.9,.5-1.8,1-2.6,1.5l.9,1.5c.8-.5,1.7-1,2.6-1.5Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M98,119.8l-.5-1.7c-1,.3-1.9,.6-2.9,1l.6,1.7c.9-.3,1.9-.7,2.8-1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M77.4,131l-1.2-1.4c-.8,.6-1.5,1.3-2.3,2l1.2,1.3c.7-.7,1.5-1.3,2.2-1.9Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M89.8,123c.9-.4,1.8-.8,2.7-1.2l-.7-1.7c-.9,.4-1.9,.8-2.8,1.2l.8,1.6Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M69.7,136l1.3,1.2c.7-.7,1.3-1.5,2-2.2l-1.3-1.3c-.7,.7-1.4,1.5-2.1,2.2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.7,102.2l-1.1-1.4c-.8,.6-1.6,1.3-2.3,2.1l1.3,1.3c.7-.7,1.4-1.3,2.2-1.9Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M50.5,171.2h1.8c0-.8,.1-1.8,.2-2.9h-1.8c0,1-.1,2-.2,2.9Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M78.6,99.6l-.8-1.6c-.6,.3-1.1,.6-1.7,1l1,1.5c.5-.3,1-.6,1.6-.9Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M64.3,116.2l-1.6-.8c-.4,.9-.9,1.8-1.3,2.8l1.6,.7c.4-.9,.8-1.8,1.3-2.7Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M61.9,121.6l-1.7-.7c-.4,.9-.7,1.9-1.1,2.8l1.7,.6c.3-.9,.7-1.9,1.1-2.8Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M67.1,111l-1.5-1c-.5,.8-1,1.7-1.6,2.6l1.6,.9c.5-.9,1-1.7,1.5-2.5Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M70.6,106.3l-1.4-1.2c-.6,.8-1.3,1.6-1.9,2.4l1.5,1.1c.6-.8,1.2-1.6,1.8-2.3Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M54.5,150.5l-1.8-.3c-.1,.9-.3,1.8-.4,2.7h-.6v1.5h1.9v-1h.4c.1-.9,.3-1.9,.4-2.9Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.3,159.4c.1-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.4,3l1.8,.2Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M51,165.2l1.8,.2c0-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.3,3Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M55.5,144.6l-1.8-.3c-.2,1-.4,2-.5,3l1.8,.3c.2-1,.3-2,.5-2.9Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M56.7,138.7l-1.8-.4c-.2,1-.4,2-.6,3l1.8,.4c.2-1,.4-1.9,.6-2.9Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M59.8,127.2l-1.7-.6c-.3,1-.6,1.9-.9,2.9l1.7,.5c.3-1,.6-1.9,.9-2.8Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M58.1,133l-1.7-.5c-.3,1-.5,2-.8,2.9l1.8,.4c.2-1,.5-1.9,.7-2.9Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M35.2,96.3l1.3-1.2c-.7-.8-1.2-1.1-1.2-1.1l-1.1,1.4s.4,.3,1,.9Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M39.8,99.4c-.5-.8-1-1.5-1.5-2.2l-1.4,1.1c.5,.6,1,1.4,1.5,2.1l1.5-1Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M40.8,104.8l1.6-.8c-.4-.9-.8-1.6-1.3-2.4l-1.6,.9c.4,.7,.8,1.5,1.2,2.3Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M43,109.6l1.7-.7c-.3-.9-.7-1.7-1-2.4l-1.6,.7c.3,.8,.7,1.5,1,2.4Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M49.6,134.7l1.8-.3c-.1-.9-.3-1.8-.4-2.6l-1.8,.3c.2,.8,.3,1.7,.4,2.6Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M50.4,139.9l1.8-.2c-.1-.9-.2-1.8-.4-2.6l-1.8,.3c.1,.8,.2,1.7,.4,2.6Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M48.7,129.6l1.8-.3c-.2-.9-.4-1.7-.5-2.6l-1.8,.4c.2,.8,.4,1.7,.5,2.6Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M51,145.1l1.8-.2c0-.9-.2-1.8-.3-2.6l-1.8,.2c.1,.9,.2,1.7,.3,2.6Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M47.6,124.5l1.8-.4c-.2-.9-.4-1.7-.6-2.6l-1.7,.4c.2,.8,.4,1.7,.6,2.5Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M46.3,119.4l1.7-.5c-.2-.9-.5-1.7-.7-2.5l-1.7,.5c.2,.8,.5,1.6,.7,2.5Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M44.8,114.4l1.7-.6c-.3-.9-.6-1.7-.9-2.5l-1.7,.6c.3,.8,.6,1.6,.9,2.5Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M51.5,150.3l1.8-.2c0-.9-.2-1.8-.2-2.6l-1.8,.2c0,.9,.2,1.7,.2,2.6Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M41.6,141.6c-.5-.9-.9-1.8-1.4-2.7l-1.6,.9c.5,.8,.9,1.7,1.4,2.6l1.6-.8Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M50.5,170.4c-.2-1-.4-2-.6-3l-1.8,.4c.2,1,.4,1.9,.6,2.9l1.8-.3Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15,118.2c-1-.2-2.1-.3-3.1-.4v1.8c.8,0,1.8,.2,2.7,.4l.3-1.8Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20.9,119.9c-1-.4-1.9-.7-2.9-1l-.5,1.7c.9,.3,1.8,.6,2.7,1l.7-1.7Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M31.1,126.7c-.7-.7-1.5-1.4-2.3-2l-1.1,1.4c.7,.6,1.5,1.2,2.2,1.9l1.2-1.3Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M8.9,119.5v-1.8c-2,0-3.2,.4-3.2,.4l.4,1.7s1.1-.3,2.8-.3Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M35.5,134.7c.5,.8,1.1,1.6,1.6,2.5l1.5-.9c-.5-.9-1.1-1.7-1.7-2.5l-1.5,1Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M26.3,122.9c-.9-.6-1.7-1.1-2.6-1.6l-.9,1.6c.8,.5,1.7,1,2.5,1.5l1-1.5Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M46.1,152.8c-.3-1-.7-1.9-1-2.9l-1.7,.6c.3,.9,.7,1.8,1,2.8l1.7-.6Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M44.1,147.1c-.4-1-.8-1.9-1.2-2.8l-1.6,.7c.4,.9,.8,1.8,1.2,2.7l1.7-.7Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M47.9,158.6c-.3-1-.5-2-.8-2.9l-1.7,.5c.3,.9,.5,1.9,.8,2.9l1.7-.5Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M35.2,131.3c-.6-.8-1.3-1.6-2-2.3l-1.3,1.2c.6,.7,1.3,1.5,1.9,2.2l1.4-1.1Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M49.3,164.4c-.2-1-.5-2-.7-2.9l-1.8,.4c.2,.9,.5,1.9,.7,2.9l1.8-.4Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M125.9,148.8l-1.7-.6c-.4,1-.7,1.9-1,2.9l1.7,.5c.3-.9,.6-1.9,1-2.8Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M128.1,143.2l-1.6-.7c-.4,.9-.8,1.9-1.2,2.8l1.7,.7c.4-.9,.7-1.8,1.2-2.7Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M134.1,129.4l1.5,1.1c.6-.8,1.2-1.6,1.8-2.3l-1.4-1.1c-.6,.8-1.3,1.6-1.9,2.4Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M121.7,166.1l-1.4-.2c0-.3,0-1.3,0-2.9h-1c0-.4,0-.7-.2-1l-1.8,.3c.2,1,.3,1.9,.5,2.9h.6c0,.5,0,.8,0,.8h1.4c-.1,.9-.2,1.5-.2,2l-1.4,.2c0,.5,.1,1,.2,1.5l1.8-.2c0-.2,0-.4,0-.6h1.2s0-1,.3-2.9Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M124.1,154.4l-1.7-.5c-.3,1-.5,2-.8,2.9l1.8,.4c.2-.9,.5-1.9,.8-2.9Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M122.7,160.2l-1.8-.4c-.2,1.1-.4,2.1-.6,3l1.8,.3c.1-.9,.3-1.9,.5-2.9Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M130.8,137.9l-1.6-.9c-.5,.9-1,1.8-1.4,2.7l1.6,.8c.4-.9,.9-1.8,1.4-2.6Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M157.5,110.9s0,0,0,0l.4,.8c.2,0,.4-.2,.6-.2,.5,.3,1,.6,1.5,.9l1-1.5c-.2-.1-.3-.2-.5-.3,0,0,.1,0,.2,0l-.7-1.7c-.5,.2-.9,.4-1.3,.6,0,0-.2,0-.2-.1l-.2,.3c-.3,.2-.7,.3-1,.5l.4,.7h0Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M146.8,116.4l1.1,1.4c.8-.6,1.6-1.2,2.4-1.7l-1-1.5c-.8,.6-1.7,1.2-2.5,1.8Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M155.3,113.1l-.9-1.6c-.9,.5-1.8,1-2.6,1.5l.9,1.5c.8-.5,1.7-1,2.6-1.5Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M171.9,106.9l-.4-1.8c-1,.2-2,.5-2.9,.7l.5,1.7c.9-.3,1.9-.5,2.9-.7Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M133.8,132.9l-1.5-1c-.6,.9-1.1,1.7-1.6,2.6l1.5,.9c.5-.8,1-1.7,1.6-2.5Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M142.1,120.3l1.2,1.3c.7-.7,1.5-1.3,2.2-1.9l-1.2-1.4c-.8,.6-1.5,1.3-2.3,2Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M166.2,108.5l-.5-1.7c-1,.3-1.9,.6-2.9,1l.6,1.7c.9-.3,1.9-.7,2.8-1Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M137.9,124.6l1.3,1.2c.7-.7,1.3-1.5,2-2.2l-1.3-1.3c-.7,.7-1.4,1.5-2.1,2.2Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M118.7,159.9h1.8c0-.8,.1-1.8,.2-2.9h-1.8c0,1-.1,2-.2,2.9Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M122.7,139.2l-1.8-.3c0,.2,0,.4,0,.6h-1.1c0,1.1,.2,2.1,.2,3.1h1.8c0-.3,0-.4,0-.5h.5c.1-.9,.3-1.9,.4-2.9Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M132.4,104.9l-1.6-.8c-.4,.9-.9,1.8-1.3,2.8l1.6,.7c.4-.9,.8-1.8,1.3-2.7Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M138.7,95l-1.4-1.2c-.6,.8-1.3,1.6-1.9,2.4l1.5,1.1c.6-.8,1.2-1.6,1.8-2.3Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M146.8,88.3l-.8-1.6c-.6,.3-1.1,.6-1.7,1l1,1.5c.5-.3,1-.6,1.6-.9Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M121.5,148.1c.1-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.4,3l1.8,.2Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M119.1,153.9l1.8,.2c0-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.3,3Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M135.3,99.7l-1.5-1c-.5,.8-1,1.7-1.6,2.6l1.6,.9c.5-.9,1-1.7,1.5-2.5Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M142.9,90.9l-1.1-1.4c-.8,.6-1.6,1.3-2.3,2.1l1.3,1.3c.7-.7,1.4-1.3,2.2-1.9Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M123.7,133.3l-1.8-.3c-.2,1-.4,2-.5,3l1.8,.3c.2-1,.3-2,.5-2.9Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M124.9,127.4l-1.8-.4c-.2,1-.4,2-.6,3l1.8,.4c.2-1,.4-1.9,.6-2.9Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M130,110.3l-1.7-.7c-.4,.9-.7,1.9-1.1,2.8l1.7,.6c.3-.9,.7-1.9,1.1-2.8Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M126.3,121.6l-1.7-.5c-.3,1-.5,2-.8,2.9l1.8,.4c.2-1,.5-1.9,.7-2.9Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M128,115.9l-1.7-.6c-.3,1-.6,1.9-.9,2.9l1.7,.5c.3-1,.6-1.9,.9-2.8Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M109.2,90c-.5-.9-1.1-1.8-1.6-2.6l-1.5,1c.5,.8,1,1.6,1.5,2.5l1.6-.9Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M110.3,96.2l1.6-.7c-.4-.9-.9-1.9-1.3-2.8l-1.6,.8c.4,.9,.9,1.8,1.3,2.7Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M104.3,86.1l1.4-1.1c-1.3-1.6-2.2-2.3-2.2-2.3l-1.1,1.4s.8,.6,1.9,2Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M112.5,101.7l1.7-.6c-.4-1-.7-1.9-1.1-2.8l-1.7,.7c.3,.9,.7,1.8,1,2.8Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M114.3,107.3l1.7-.5c-.3-1-.6-2-.9-2.9l-1.7,.5c.3,.9,.6,1.9,.9,2.8Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M119.5,136.7l1.8-.2c0-1-.2-2-.3-3l-1.8,.2c.1,1,.2,2,.3,3Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M115.8,113.1l1.8-.4c-.2-1-.5-2-.7-2.9l-1.7,.5c.2,.9,.5,1.9,.7,2.9Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M118.8,130.7l1.8-.2c-.1-1-.3-2-.4-3l-1.8,.2c.1,1,.3,2,.4,3Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M118,124.8l1.8-.3c-.2-1-.3-2-.5-3l-1.8,.3c.2,1,.3,1.9,.5,2.9Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M117,118.9l1.8-.3c-.2-1-.4-2-.6-3l-1.8,.4c.2,.9,.4,1.9,.6,2.9Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M101.9,121.1l1.4-1.1c-.4-.5-.7-.9-1.1-1.4,.5-.1,1-.3,1.5-.4l-.4-1.8c-1,.2-2,.5-2.9,.7l.3,1-.6,.6c.6,.7,1.3,1.5,1.9,2.2Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M76.9,106.4c-1.9,0-3.1,.4-3.2,.4l.4,1.7s1.1-.3,2.8-.3v-1.8Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M99.2,115.4c-.7-.7-1.5-1.4-2.3-2l-1.1,1.4c.7,.6,1.5,1.2,2.2,1.9l1.2-1.3Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M89,108.6c-1-.4-1.9-.7-2.9-1l-.5,1.7c.9,.3,1.8,.6,2.7,1l.7-1.7Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M83.1,106.9c-1-.2-2.1-.3-3.1-.4v1.8c.8,0,1.8,.2,2.7,.4l.3-1.8Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M94.5,111.6c-.9-.6-1.7-1.1-2.6-1.6l-.9,1.6c.8,.5,1.7,1,2.5,1.5l1-1.5Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M103.7,123.4c.5,.8,1.1,1.6,1.6,2.5l1.5-.9c-.5-.9-1.1-1.7-1.7-2.5l-1.5,1Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M118.7,159c-.2-1-.4-2-.6-3l-1.8,.4c.2,1,.4,1.9,.6,2.9l1.8-.3Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M116.1,147.3c-.3-1-.5-2-.8-2.9l-1.7,.5c.3,.9,.5,1.9,.8,2.9l1.7-.5Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M117.5,153.1c-.2-1-.5-2-.7-2.9l-1.8,.4c.2,.9,.5,1.9,.7,2.9l1.8-.4Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M109.8,130.3c-.5-.9-.9-1.8-1.4-2.7l-1.6,.9c.5,.8,.9,1.7,1.4,2.6l1.6-.8Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M114.3,141.5c-.3-1-.7-1.9-1-2.9l-1.7,.6c.3,.9,.7,1.8,1,2.8l1.7-.6Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M112.2,135.8c-.4-1-.8-1.9-1.2-2.8l-1.6,.7c.4,.9,.8,1.8,1.2,2.7l1.7-.7Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M200.4,132.2l-1.5-1c-.6,.9-1.1,1.7-1.6,2.6l1.5,.9c.5-.8,1-1.7,1.6-2.5Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M200.6,128.7l1.5,1.1c.6-.8,1.2-1.6,1.8-2.3l-1.4-1.1c-.6,.8-1.3,1.6-1.9,2.4Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M197.3,137.3l-1.6-.9c-.5,.9-1,1.8-1.4,2.7l1.6,.8c.4-.9,.9-1.8,1.4-2.6Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M188.3,165.4l-1.4-.2c0-.3,0-1.3,0-2.9h-1c0-.4,0-.7-.2-1l-1.8,.3c.2,1,.3,1.9,.5,2.9h.6c0,.5,0,.8,0,.8h1.4c-.1,.9-.2,1.5-.2,2l-1.4,.2c0,.5,.1,1,.2,1.5l1.8-.2c0-.2,0-.4,0-.6h1.2s0-1,.3-2.9Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M194.7,142.6l-1.6-.7c-.4,.9-.8,1.9-1.2,2.8l1.7,.7c.4-.9,.7-1.8,1.2-2.7Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M189.3,159.6l-1.8-.4c-.2,1.1-.4,2.1-.6,3l1.8,.3c.1-.9,.3-1.9,.5-2.9Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M190.7,153.8l-1.7-.5c-.3,1-.5,2-.8,2.9l1.8,.4c.2-.9,.5-1.9,.8-2.9Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M192.5,148.1l-1.7-.6c-.4,1-.7,1.9-1,2.9l1.7,.5c.3-.9,.6-1.9,1-2.8Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M204.4,124l1.3,1.2c.7-.7,1.3-1.5,2-2.2l-1.3-1.3c-.7,.7-1.4,1.5-2.1,2.2Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M232.8,107.8l-.5-1.7c-1,.3-1.9,.6-2.9,1l.6,1.7c.9-.3,1.9-.7,2.8-1Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M221.9,112.4l-.9-1.6c-.9,.5-1.8,1-2.6,1.5l.9,1.5c.8-.5,1.7-1,2.6-1.5Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M238.5,106.3l-.4-1.8c-1,.2-2,.5-2.9,.7l.5,1.7c.9-.3,1.9-.5,2.9-.7Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M216.9,115.5l-1-1.5c-.8,.6-1.7,1.2-2.5,1.8l1.1,1.4c.8-.6,1.6-1.2,2.4-1.7Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M227.2,109.9l-.7-1.7c-.9,.4-1.9,.8-2.8,1.2l.8,1.6c.9-.4,1.8-.8,2.7-1.2Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M211,117.7c-.8,.6-1.5,1.3-2.3,2l.5,.5,.4,1.6s1.1-.3,2.8-.3v-1.8c-.5,0-.8,0-1.1,0,.3-.2,.5-.5,.8-.7l-1.2-1.4Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M201.9,99.1l-1.5-1c-.5,.8-1,1.7-1.6,2.6l1.6,.9c.5-.9,1-1.7,1.5-2.5Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M213.4,87.7l-.8-1.6c-.6,.3-1.1,.6-1.7,1l1,1.5c.5-.3,1-.6,1.6-.9Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M205.3,94.3l-1.4-1.2c-.6,.8-1.3,1.6-1.9,2.4l1.5,1.1c.6-.8,1.2-1.6,1.8-2.3Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M185.3,159.3h1.8c0-.8,.1-1.8,.2-2.9h-1.8c0,1-.1,2-.2,2.9Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M199,104.3l-1.6-.8c-.4,.9-.9,1.8-1.3,2.8l1.6,.7c.4-.9,.8-1.8,1.3-2.7Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M209.4,90.3l-1.1-1.4c-.8,.6-1.6,1.3-2.3,2.1l1.3,1.3c.7-.7,1.4-1.3,2.2-1.9Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M190.2,132.6l-1.8-.3c-.2,1-.4,2-.5,3l1.8,.3c.2-1,.3-2,.5-2.9Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M185.7,153.3l1.8,.2c0-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.3,3Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M188.1,147.4c.1-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.4,3l1.8,.2Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M196.6,109.7l-1.7-.7c-.4,.9-.7,1.9-1.1,2.8l1.7,.6c.3-.9,.7-1.9,1.1-2.8Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M189.2,138.5l-1.8-.3c0,.2,0,.4,0,.6h-1.1c0,1.1,.2,2.1,.2,3.1h1.8c0-.3,0-.4,0-.5h.5c.1-.9,.3-1.9,.4-2.9Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M194.6,115.3l-1.7-.6c-.3,1-.6,1.9-.9,2.9l1.7,.5c.3-1,.6-1.9,.9-2.8Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M192.9,121l-1.7-.5c-.3,1-.5,2-.8,2.9l1.8,.4c.2-1,.5-1.9,.7-2.9Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M191.4,126.8l-1.8-.4c-.2,1-.4,2-.6,3l1.8,.4c.2-1,.4-1.9,.6-2.9Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M175.7,89.4c-.5-.9-1.1-1.8-1.6-2.6l-1.5,1c.5,.8,1,1.6,1.5,2.5l1.6-.9Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M180.8,106.7l1.7-.5c-.3-1-.6-2-.9-2.9l-1.7,.5c.3,.9,.6,1.9,.9,2.8Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M179,101l1.7-.6c-.4-1-.7-1.9-1.1-2.8l-1.7,.7c.3,.9,.7,1.8,1,2.8Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M182.3,112.5l1.8-.4c-.2-1-.5-2-.7-2.9l-1.7,.5c.2,.9,.5,1.9,.7,2.9Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M176.8,95.5l1.6-.7c-.4-.9-.9-1.9-1.3-2.8l-1.6,.8c.4,.9,.9,1.8,1.3,2.7Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M170.9,85.4l1.4-1.1c-1.3-1.6-2.2-2.3-2.2-2.3l-1.1,1.4s.8,.6,1.9,2Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M183.6,118.3l1.8-.3c-.2-1-.4-2-.6-3l-1.8,.4c.2,.9,.4,1.9,.6,2.9Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M186,136l1.8-.2c0-1-.2-2-.3-3l-1.8,.2c.1,1,.2,2,.3,3Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M184.6,124.2l1.8-.3c-.2-1-.3-2-.5-3l-1.8,.3c.2,1,.3,1.9,.5,2.9Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M185.4,130.1l1.8-.2c-.1-1-.3-2-.4-3l-1.8,.2c.1,1,.3,2,.4,3Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M146.5,107.6c1,0,1.9,.2,2.9,.4l.3-1.8c-1-.2-2.1-.3-3.1-.4v1.8Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M169.9,119.3c-.6-.8-1.3-1.6-2-2.3l-1.3,1.2c.6,.7,1.3,1.5,1.9,2.2l1.4-1.1Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M165.8,114.8c-.7-.7-1.5-1.4-2.3-2l-1.1,1.4c.7,.6,1.5,1.2,2.2,1.9l1.2-1.3Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M155.6,108c-1-.4-1.9-.7-2.9-1l-.5,1.7c.9,.3,1.8,.6,2.7,1l.7-1.7Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M178.8,135.1c-.4-1-.8-1.9-1.2-2.8l-1.6,.7c.4,.9,.8,1.8,1.2,2.7l1.7-.7Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M182.6,146.6c-.3-1-.5-2-.8-2.9l-1.7,.5c.3,.9,.5,1.9,.8,2.9l1.7-.5Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M140.8,107.9s1.1-.3,2.8-.3v-1.8c-2,0-3.2,.4-3.2,.4l.4,1.7Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M185.2,158.4c-.2-1-.4-2-.6-3l-1.8,.4c.2,1,.4,1.9,.6,2.9l1.8-.3Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M176.3,129.6c-.5-.9-.9-1.8-1.4-2.7l-1.6,.9c.5,.8,.9,1.7,1.4,2.6l1.6-.8Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M170.2,122.8c.5,.8,1.1,1.6,1.6,2.5l1.5-.9c-.5-.9-1.1-1.7-1.7-2.5l-1.5,1Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M180.9,140.8c-.3-1-.7-1.9-1-2.9l-1.7,.6c.3,.9,.7,1.8,1,2.8l1.7-.6Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M184.1,152.5c-.2-1-.5-2-.7-2.9l-1.8,.4c.2,.9,.5,1.9,.7,2.9l1.8-.4Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M257.2,179.4l-1.6-.3c0-.4,0-1.4,0-2.8h-1c0-.4,0-.7-.2-1l-1.8,.3c.2,1,.3,1.9,.5,2.9h.6c0,.5,0,.8,0,.8h1.5c-.1,.8-.2,1.5-.3,2l-1.4,.2c0,.5,.1,1,.2,1.5l1.8-.2c0-.2,0-.4,0-.6h1.2c0,0,0-1,.4-2.8Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M271,149.9l1.3,1.3c.7-.7,1.4-1.3,2.2-2l-1.2-1.4c-.8,.7-1.5,1.4-2.2,2.1Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M260.6,168.1l-1.7-.7c-.4,.9-.8,1.9-1.1,2.8l1.7,.6c.3-.9,.7-1.8,1.1-2.7Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M258.6,173.6l-1.7-.5c-.3,1-.6,2-.8,2.9l1.8,.4c.2-.9,.5-1.9,.8-2.8Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M266.9,154.4l1.4,1.1c.6-.8,1.3-1.5,1.9-2.2l-1.3-1.2c-.7,.7-1.4,1.5-2,2.3Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M263.3,159.3l1.5,1c.5-.8,1.1-1.6,1.7-2.4l-1.5-1.1c-.6,.8-1.2,1.7-1.7,2.5Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M306.4,134.7l-.3-1.8c-1,.2-2,.4-3,.6l.4,1.8c1-.2,1.9-.4,2.9-.6Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M275.6,145.9l1.1,1.4c.8-.6,1.6-1.2,2.4-1.7l-1-1.5c-.8,.6-1.7,1.2-2.5,1.8Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M300.6,136l-.5-1.7c-1,.3-2,.5-2.9,.8l.5,1.7c.9-.3,1.9-.5,2.9-.8Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M263.3,162.8l-1.6-.9c-.5,.9-1,1.8-1.4,2.7l1.6,.8c.4-.9,.9-1.8,1.4-2.6Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M281.6,144c.8-.5,1.7-1,2.5-1.5l-.9-1.6c-.9,.5-1.8,1-2.6,1.5l1,1.5Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M289.4,139.8l-.7-1.6c-.9,.4-1.9,.8-2.8,1.3l.8,1.6c.9-.4,1.8-.9,2.7-1.3Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M294.9,137.7l-.6-1.7c-1,.3-1.9,.7-2.8,1l.7,1.7c.9-.4,1.8-.7,2.8-1Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M265.4,123.6l-1.7-.7c-.4,.9-.7,1.9-1.1,2.8l1.7,.6c.3-.9,.7-1.9,1.1-2.8Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M267.8,118.1l-1.6-.8c-.4,.9-.9,1.8-1.3,2.8l1.6,.7c.4-.9,.8-1.8,1.3-2.7Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M263.4,129.2l-1.7-.6c-.3,1-.6,1.9-.9,2.9l1.7,.5c.3-1,.6-1.9,.9-2.8Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M258.1,152.4l-1.8-.3c0,.2,0,.4,0,.6h-1.1c0,1.1,.2,2.1,.2,3.1h1.8c0-.3,0-.4,0-.5h.5c.1-.9,.3-1.9,.4-2.9Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M254.5,167.2l1.8,.2c0-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.3,3Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M270.7,113l-1.5-1c-.5,.8-1,1.7-1.6,2.6l1.6,.9c.5-.9,1-1.7,1.5-2.5Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M278.3,104.2l-1.1-1.4c-.8,.6-1.6,1.3-2.3,2.1l1.3,1.3c.7-.7,1.4-1.3,2.2-1.9Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M282.2,101.6l-.8-1.6c-.6,.3-1.1,.6-1.7,1l1,1.5c.5-.3,1-.6,1.6-.9Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M274.1,108.2l-1.4-1.2c-.6,.8-1.3,1.6-1.9,2.4l1.5,1.1c.6-.8,1.2-1.6,1.8-2.3Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M254.1,173.2h1.8c0-.8,.1-1.8,.2-2.9h-1.8c0,1-.1,2-.2,2.9Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M256.9,161.3c.1-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.4,3l1.8,.2Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M260.3,140.7l-1.8-.4c-.2,1-.4,2-.6,3l1.8,.4c.2-1,.4-1.9,.6-2.9Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M261.7,134.9l-1.7-.5c-.3,1-.5,2-.8,2.9l1.8,.4c.2-1,.5-1.9,.7-2.9Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M259.1,146.5l-1.8-.3c-.2,1-.4,2-.5,3l1.8,.3c.2-1,.3-2,.5-2.9Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M251.1,126.4l1.8-.4c-.2-1-.5-2-.7-2.9l-1.7,.5c.2,.9,.5,1.9,.7,2.9Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M245.6,109.4l1.6-.7c-.4-.9-.9-1.9-1.3-2.8l-1.6,.8c.4,.9,.9,1.8,1.3,2.7Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M254.2,144l1.8-.2c-.1-1-.3-2-.4-3l-1.8,.2c.1,1,.3,2,.4,3Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M239.7,99.3l1.4-1.1c-1.3-1.6-2.2-2.3-2.2-2.3l-1.1,1.4s.8,.6,1.9,2Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M244.6,103.3c-.5-.9-1.1-1.8-1.6-2.6l-1.5,1c.5,.8,1,1.6,1.5,2.5l1.6-.9Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M254.9,149.9l1.8-.2c0-1-.2-2-.3-3l-1.8,.2c.1,1,.2,2,.3,3Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M247.8,114.9l1.7-.6c-.4-1-.7-1.9-1.1-2.8l-1.7,.7c.3,.9,.7,1.8,1,2.8Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M252.4,132.2l1.8-.3c-.2-1-.4-2-.6-3l-1.8,.4c.2,.9,.4,1.9,.6,2.9Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M249.6,120.6l1.7-.5c-.3-1-.6-2-.9-2.9l-1.7,.5c.3,.9,.6,1.9,.9,2.8Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M253.4,138.1l1.8-.3c-.2-1-.3-2-.5-3l-1.8,.3c.2,1,.3,1.9,.5,2.9Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M215.3,121.5c1,0,1.9,.2,2.9,.4l.3-1.8c-1-.2-2.1-.3-3.1-.4v1.8Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M226.3,124.8c.8,.5,1.7,1,2.5,1.5l1-1.5c-.9-.6-1.7-1.1-2.6-1.6l-.9,1.6Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M231.2,128c.7,.6,1.5,1.2,2.2,1.9l1.2-1.3c-.7-.7-1.5-1.4-2.3-2l-1.1,1.4Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M221,122.6c.9,.3,1.8,.6,2.7,1l.7-1.7c-1-.4-1.9-.7-2.9-1l-.5,1.7Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M249.7,154.7c-.3-1-.7-1.9-1-2.9l-1.7,.6c.3,.9,.7,1.8,1,2.8l1.7-.6Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M252.9,166.4c-.2-1-.5-2-.7-2.9l-1.8,.4c.2,.9,.5,1.9,.7,2.9l1.8-.4Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M251.4,160.5c-.3-1-.5-2-.8-2.9l-1.7,.5c.3,.9,.5,1.9,.8,2.9l1.7-.5Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M254.1,172.3c-.2-1-.4-2-.6-3l-1.8,.4c.2,1,.4,1.9,.6,2.9l1.8-.3Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M239.1,136.7c.5,.8,1.1,1.6,1.6,2.5l1.5-.9c-.5-.9-1.1-1.7-1.7-2.5l-1.5,1Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M247.6,149c-.4-1-.8-1.9-1.2-2.8l-1.6,.7c.4,.9,.8,1.8,1.2,2.7l1.7-.7Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M245.2,143.5c-.5-.9-.9-1.8-1.4-2.7l-1.6,.9c.5,.8,.9,1.7,1.4,2.6l1.6-.8Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M235.4,132.1c.6,.7,1.3,1.5,1.9,2.2l1.4-1.1c-.6-.8-1.3-1.6-2-2.3l-1.3,1.2Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M351.9,177.4l-1.4-.2c0-.3,0-1.3,0-2.9h-1.8s0,.1,0,.2c-.3-.9-.6-1.7-.9-2.5l-1.7,.7c.3,.9,.7,1.8,1,2.8l1.6-.5c0,1.5,0,2.4,0,2.4h1.4c0,.6-.1,1-.2,1.4,0-.3-.1-.6-.2-.9l-1.7,.5c.2,.9,.5,1.9,.7,2.9l1.8-.4c0-.2,0-.3-.1-.5h1.3s0-1,.3-2.9Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M360.9,149.2l-1.6-.9c-.5,.9-1,1.8-1.4,2.7l1.6,.8c.4-.9,.9-1.8,1.4-2.6Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M352.9,171.5l-1.8-.4c-.2,1.1-.4,2.1-.6,3l1.8,.3c.1-.9,.3-1.9,.5-2.9Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M358.3,154.6l-1.6-.7c-.4,.9-.8,1.9-1.2,2.8l1.7,.7c.4-.9,.7-1.8,1.2-2.7Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M356.1,160.1l-1.7-.6c-.4,1-.7,1.9-1,2.9l1.7,.5c.3-.9,.6-1.9,1-2.8Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M364.2,140.7l1.5,1.1c.6-.8,1.2-1.6,1.8-2.3l-1.4-1.1c-.6,.8-1.3,1.6-1.9,2.4Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M354.3,165.7l-1.7-.5c-.3,1-.5,2-.8,2.9l1.8,.4c.2-.9,.5-1.9,.8-2.9Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M388.1,123c.9-.4,1.8-.8,2.7-1.2l-.7-1.7c-.9,.4-1.9,.8-2.8,1.2l.8,1.6Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M396.4,119.8l-.5-1.7c-1,.3-1.9,.6-2.9,1l.6,1.7c.9-.3,1.9-.7,2.8-1Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M385.5,124.4l-.9-1.6c-.9,.5-1.8,1-2.6,1.5l.9,1.5c.8-.5,1.7-1,2.6-1.5Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M380.5,127.4l-1-1.5c-.8,.6-1.7,1.2-2.5,1.8l1.1,1.4c.8-.6,1.6-1.2,2.4-1.7Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M375.7,131l-1.2-1.4c-.8,.6-1.5,1.3-2.3,2l1.2,1.3c.7-.7,1.5-1.3,2.2-1.9Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M368,136l1.3,1.2c.7-.7,1.3-1.5,2-2.2l-1.3-1.3c-.7,.7-1.4,1.5-2.1,2.2Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M364,144.2l-1.5-1c-.6,.9-1.1,1.7-1.6,2.6l1.5,.9c.5-.8,1-1.7,1.6-2.5Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M348.9,171.2h1.8c0-.8,.1-1.8,.2-2.9h-1.8c0,1-.1,2-.2,2.9Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M351.7,159.4c.1-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.4,3l1.8,.2Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M373,102.2l-1.1-1.4c-.8,.6-1.6,1.3-2.3,2.1l1.3,1.3c.7-.7,1.4-1.3,2.2-1.9Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M360.2,121.6l-1.7-.7c-.4,.9-.7,1.9-1.1,2.8l1.7,.6c.3-.9,.7-1.9,1.1-2.8Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M362.6,116.2l-1.6-.8c-.4,.9-.9,1.8-1.3,2.8l1.6,.7c.4-.9,.8-1.8,1.3-2.7Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M368.9,106.3l-1.4-1.2c-.6,.8-1.3,1.6-1.9,2.4l1.5,1.1c.6-.8,1.2-1.6,1.8-2.3Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M352.8,150.5l-1.8-.3c0,.2,0,.4,0,.6h-1.1c0,1.1,.2,2.1,.2,3.1h1.8c0-.3,0-.4,0-.5h.5c.1-.9,.3-1.9,.4-2.9Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M365.5,111l-1.5-1c-.5,.8-1,1.7-1.6,2.6l1.6,.9c.5-.9,1-1.7,1.5-2.5Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M377,99.6l-.8-1.6c-.6,.3-1.1,.6-1.7,1l1,1.5c.5-.3,1-.6,1.6-.9Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M349.3,165.2l1.8,.2c0-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.3,3Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M353.8,144.6l-1.8-.3c-.2,1-.4,2-.5,3l1.8,.3c.2-1,.3-2,.5-2.9Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M355,138.7l-1.8-.4c-.2,1-.4,2-.6,3l1.8,.4c.2-1,.4-1.9,.6-2.9Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M358.2,127.2l-1.7-.6c-.3,1-.6,1.9-.9,2.9l1.7,.5c.3-1,.6-1.9,.9-2.8Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M356.5,133l-1.7-.5c-.3,1-.5,2-.8,2.9l1.8,.4c.2-1,.5-1.9,.7-2.9Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M349.6,148l1.8-.2c0-1-.2-2-.3-3l-1.8,.2c.1,1,.2,2,.3,3Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M349,142l1.8-.2c-.1-1-.3-2-.4-3l-1.8,.2c.1,1,.3,2,.4,3Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M334.5,97.4l1.4-1.1c-1.3-1.6-2.2-2.3-2.2-2.3l-1.1,1.4s.8,.6,1.9,2Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M348.2,136.1l1.8-.3c-.2-1-.3-2-.5-3l-1.8,.3c.2,1,.3,1.9,.5,2.9Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M347.2,130.2l1.8-.3c-.2-1-.4-2-.6-3l-1.8,.4c.2,.9,.4,1.9,.6,2.9Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M340.4,107.5l1.6-.7c-.4-.9-.9-1.9-1.3-2.8l-1.6,.8c.4,.9,.9,1.8,1.3,2.7Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M342.6,113l1.7-.6c-.4-1-.7-1.9-1.1-2.8l-1.7,.7c.3,.9,.7,1.8,1,2.8Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M344.4,118.7l1.7-.5c-.3-1-.6-2-.9-2.9l-1.7,.5c.3,.9,.6,1.9,.9,2.8Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M345.9,124.4l1.8-.4c-.2-1-.5-2-.7-2.9l-1.7,.5c.2,.9,.5,1.9,.7,2.9Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M339.3,101.3c-.5-.9-1.1-1.8-1.6-2.6l-1.5,1c.5,.8,1,1.6,1.5,2.5l1.6-.9Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M304.3,147.4s1.1-.2,2.9-.2v-1.8c-2,0-3.1,.2-3.1,.2l.3,1.8Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M325.1,148.5c-.9-.4-1.9-.7-2.9-1l-.5,1.7c.9,.3,1.9,.6,2.8,1l.7-1.7Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M319.3,146.6c-1-.2-2-.4-3-.6l-.3,1.8c1,.2,1.9,.4,2.9,.6l.4-1.8Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M313.2,145.6c-1-.1-2-.2-3.1-.2v1.8c.9,0,1.9,.1,2.9,.2l.2-1.8Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M346.6,169.2c-.4-.9-.9-1.8-1.4-2.7l-1.6,.9c.5,.8,.9,1.7,1.3,2.6l1.6-.8Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M330.6,151.1c-.9-.5-1.8-1-2.7-1.4l-.8,1.6c.9,.4,1.7,.9,2.6,1.4l.9-1.6Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M336.7,158c.7,.7,1.4,1.4,2,2.1l1.4-1.2c-.7-.8-1.4-1.5-2.1-2.2l-1.3,1.3Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M340.5,162.4c.6,.8,1.1,1.6,1.7,2.4l1.5-1c-.5-.9-1.1-1.7-1.7-2.5l-1.4,1.1Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M335.7,154.7c-.8-.6-1.6-1.3-2.4-1.9l-1,1.5c.8,.6,1.6,1.2,2.3,1.8l1.2-1.4Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M429.1,137.9l-1.6-.9c-.5,.9-1,1.8-1.4,2.7l1.6,.8c.4-.9,.9-1.8,1.4-2.6Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M426.4,143.2l-1.6-.7c-.4,.9-.8,1.9-1.2,2.8l1.7,.7c.4-.9,.7-1.8,1.2-2.7Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M432.4,129.4l1.5,1.1c.6-.8,1.2-1.6,1.8-2.3l-1.4-1.1c-.6,.8-1.3,1.6-1.9,2.4Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M424.2,148.8l-1.7-.6c-.4,1-.7,1.9-1,2.9l1.7,.5c.3-.9,.6-1.9,1-2.8Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M421,160.2l-1.8-.4c-.2,1.1-.4,2.1-.6,3l1.8,.3c.1-.9,.3-1.9,.5-2.9Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M422.4,154.4l-1.7-.5c-.3,1-.5,2-.8,2.9l1.8,.4c.2-.9,.5-1.9,.8-2.9Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M420.1,166.1l-1.4-.2c0-.3,0-1.3,0-2.9h-1c0-.4,0-.7-.2-1l-1.8,.3c.2,1,.3,1.9,.5,2.9h.6c0,.5,0,.8,0,.8h1.4c-.1,.9-.2,1.5-.2,2l-1.4,.2c0,.5,.1,1,.2,1.5l1.8-.2c0-.2,0-.4,0-.6h1.2s0-1,.3-2.9Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M470.2,106.9l-.4-1.8c-1,.2-2,.5-2.9,.7l.5,1.7c.9-.3,1.9-.5,2.9-.7Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M464.5,108.5l-.5-1.7c-1,.3-1.9,.6-2.9,1l.6,1.7c.9-.3,1.9-.7,2.8-1Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M432.1,132.9l-1.5-1c-.6,.9-1.1,1.7-1.6,2.6l1.5,.9c.5-.8,1-1.7,1.6-2.5Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M455.9,110.9s0,0,0,0l.4,.8c.2,0,.4-.2,.6-.2,.5,.3,1,.6,1.5,.9l1-1.5c-.2-.1-.3-.2-.5-.3,0,0,.1,0,.2,0l-.7-1.7c-.5,.2-.9,.4-1.3,.6,0,0-.2,0-.2-.1l-.2,.3c-.3,.2-.7,.3-1,.5l.4,.7h0Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M453.7,113.1l-.9-1.6c-.9,.5-1.8,1-2.6,1.5l.9,1.5c.8-.5,1.7-1,2.6-1.5Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M440.5,120.3l1.2,1.3c.7-.7,1.5-1.3,2.2-1.9l-1.2-1.4c-.8,.6-1.5,1.3-2.3,2Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M445.1,116.4l1.1,1.4c.8-.6,1.6-1.2,2.4-1.7l-1-1.5c-.8,.6-1.7,1.2-2.5,1.8Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M436.2,124.6l1.3,1.2c.7-.7,1.3-1.5,2-2.2l-1.3-1.3c-.7,.7-1.4,1.5-2.1,2.2Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M417.5,153.9l1.8,.2c0-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.3,3Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M437.1,95l-1.4-1.2c-.6,.8-1.3,1.6-1.9,2.4l1.5,1.1c.6-.8,1.2-1.6,1.8-2.3Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M419.8,148.1c.1-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.4,3l1.8,.2Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M417,159.9h1.8c0-.8,.1-1.8,.2-2.9h-1.8c0,1-.1,2-.2,2.9Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M430.8,104.9l-1.6-.8c-.4,.9-.9,1.8-1.3,2.8l1.6,.7c.4-.9,.8-1.8,1.3-2.7Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M433.6,99.7l-1.5-1c-.5,.8-1,1.7-1.6,2.6l1.6,.9c.5-.9,1-1.7,1.5-2.5Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M445.1,88.3l-.8-1.6c-.6,.3-1.1,.6-1.7,1l1,1.5c.5-.3,1-.6,1.6-.9Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M441.2,90.9l-1.1-1.4c-.8,.6-1.6,1.3-2.3,2.1l1.3,1.3c.7-.7,1.4-1.3,2.2-1.9Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M421,139.2l-1.8-.3c0,.2,0,.4,0,.6h-1.1c0,1.1,.2,2.1,.2,3.1h1.8c0-.3,0-.4,0-.5h.5c.1-.9,.3-1.9,.4-2.9Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M428.4,110.3l-1.7-.7c-.4,.9-.7,1.9-1.1,2.8l1.7,.6c.3-.9,.7-1.9,1.1-2.8Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M422,133.3l-1.8-.3c-.2,1-.4,2-.5,3l1.8,.3c.2-1,.3-2,.5-2.9Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M426.3,115.9l-1.7-.6c-.3,1-.6,1.9-.9,2.9l1.7,.5c.3-1,.6-1.9,.9-2.8Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M424.6,121.6l-1.7-.5c-.3,1-.5,2-.8,2.9l1.8,.4c.2-1,.5-1.9,.7-2.9Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M423.2,127.4l-1.8-.4c-.2,1-.4,2-.6,3l1.8,.4c.2-1,.4-1.9,.6-2.9Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M402.7,86.1l1.4-1.1c-1.3-1.6-2.2-2.3-2.2-2.3l-1.1,1.4s.8,.6,1.9,2Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M417.2,130.7l1.8-.2c-.1-1-.3-2-.4-3l-1.8,.2c.1,1,.3,2,.4,3Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M416.3,124.8l1.8-.3c-.2-1-.3-2-.5-3l-1.8,.3c.2,1,.3,1.9,.5,2.9Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M415.3,118.9l1.8-.3c-.2-1-.4-2-.6-3l-1.8,.4c.2,.9,.4,1.9,.6,2.9Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M417.8,136.7l1.8-.2c0-1-.2-2-.3-3l-1.8,.2c.1,1,.2,2,.3,3Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M410.8,101.7l1.7-.6c-.4-1-.7-1.9-1.1-2.8l-1.7,.7c.3,.9,.7,1.8,1,2.8Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M412.6,107.3l1.7-.5c-.3-1-.6-2-.9-2.9l-1.7,.5c.3,.9,.6,1.9,.9,2.8Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M414.1,113.1l1.8-.4c-.2-1-.5-2-.7-2.9l-1.7,.5c.2,.9,.5,1.9,.7,2.9Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M408.6,96.2l1.6-.7c-.4-.9-.9-1.9-1.3-2.8l-1.6,.8c.4,.9,.9,1.8,1.3,2.7Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M407.5,90c-.5-.9-1.1-1.8-1.6-2.6l-1.5,1c.5,.8,1,1.6,1.5,2.5l1.6-.9Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M387.4,108.6c-1-.4-1.9-.7-2.9-1l-.5,1.7c.9,.3,1.8,.6,2.7,1l.7-1.7Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M392.8,111.6c-.9-.6-1.7-1.1-2.6-1.6l-.9,1.6c.8,.5,1.7,1,2.5,1.5l1-1.5Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M375.3,106.4c-1.9,0-3.1,.4-3.2,.4l.4,1.7s1.1-.3,2.8-.3v-1.8Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M397.6,115.4c-.7-.7-1.5-1.4-2.3-2l-1.1,1.4c.7,.6,1.5,1.2,2.2,1.9l1.2-1.3Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M400.3,121.1l1.4-1.1c-.4-.5-.7-.9-1.1-1.4,.5-.1,1-.3,1.5-.4l-.4-1.8c-1,.2-2,.5-2.9,.7l.3,1-.6,.6c.6,.7,1.3,1.5,1.9,2.2Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M412.6,141.5c-.3-1-.7-1.9-1-2.9l-1.7,.6c.3,.9,.7,1.8,1,2.8l1.7-.6Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M414.4,147.3c-.3-1-.5-2-.8-2.9l-1.7,.5c.3,.9,.5,1.9,.8,2.9l1.7-.5Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M415.8,153.1c-.2-1-.5-2-.7-2.9l-1.8,.4c.2,.9,.5,1.9,.7,2.9l1.8-.4Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M417,159c-.2-1-.4-2-.6-3l-1.8,.4c.2,1,.4,1.9,.6,2.9l1.8-.3Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M381.5,106.9c-1-.2-2.1-.3-3.1-.4v1.8c.8,0,1.8,.2,2.7,.4l.3-1.8Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M408.1,130.3c-.5-.9-.9-1.8-1.4-2.7l-1.6,.9c.5,.8,.9,1.7,1.4,2.6l1.6-.8Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M410.6,135.8c-.4-1-.8-1.9-1.2-2.8l-1.6,.7c.4,.9,.8,1.8,1.2,2.7l1.7-.7Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M402,123.4c.5,.8,1.1,1.6,1.6,2.5l1.5-.9c-.5-.9-1.1-1.7-1.7-2.5l-1.5,1Z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M486.6,165.4l-1.4-.2c0-.3,0-1.3,0-2.9h-1c0-.4,0-.7-.2-1l-1.8,.3c.2,1,.3,1.9,.5,2.9h.6c0,.5,0,.8,0,.8h1.4c-.1,.9-.2,1.5-.2,2l-1.4,.2c0,.5,.1,1,.2,1.5l1.8-.2c0-.2,0-.4,0-.6h1.2s0-1,.3-2.9Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M498.9,128.7l1.5,1.1c.6-.8,1.2-1.6,1.8-2.3l-1.4-1.1c-.6,.8-1.3,1.6-1.9,2.4Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M487.6,159.6l-1.8-.4c-.2,1.1-.4,2.1-.6,3l1.8,.3c.1-.9,.3-1.9,.5-2.9Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M495.6,137.3l-1.6-.9c-.5,.9-1,1.8-1.4,2.7l1.6,.8c.4-.9,.9-1.8,1.4-2.6Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M502.8,124l1.3,1.2c.7-.7,1.3-1.5,2-2.2l-1.3-1.3c-.7,.7-1.4,1.5-2.1,2.2Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M493,142.6l-1.6-.7c-.4,.9-.8,1.9-1.2,2.8l1.7,.7c.4-.9,.7-1.8,1.2-2.7Z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M490.8,148.1l-1.7-.6c-.4,1-.7,1.9-1,2.9l1.7,.5c.3-.9,.6-1.9,1-2.8Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M489,153.8l-1.7-.5c-.3,1-.5,2-.8,2.9l1.8,.4c.2-.9,.5-1.9,.8-2.9Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M509.3,117.7c-.8,.6-1.5,1.3-2.3,2l.5,.5,.4,1.6s1.1-.3,2.8-.3v-1.8c-.4,0-.8,0-1.1,0,.3-.2,.5-.5,.8-.7l-1.2-1.4Z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M525.6,109.9l-.7-1.7c-.9,.4-1.9,.8-2.8,1.2l.8,1.6c.9-.4,1.8-.8,2.7-1.2Z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M498.7,132.2l-1.5-1c-.6,.9-1.1,1.7-1.6,2.6l1.5,.9c.5-.8,1-1.7,1.6-2.5Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M515.2,115.5l-1-1.5c-.8,.6-1.7,1.2-2.5,1.8l1.1,1.4c.8-.6,1.6-1.2,2.4-1.7Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M520.2,112.4l-.9-1.6c-.9,.5-1.8,1-2.6,1.5l.9,1.5c.8-.5,1.7-1,2.6-1.5Z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M531.1,107.8l-.5-1.7c-1,.3-1.9,.6-2.9,1l.6,1.7c.9-.3,1.9-.7,2.8-1Z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M536.8,106.3l-.4-1.8c-1,.2-2,.5-2.9,.7l.5,1.7c.9-.3,1.9-.5,2.9-.7Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M483.6,159.3h1.8c0-.8,.1-1.8,.2-2.9h-1.8c0,1-.1,2-.2,2.9Z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M500.2,99.1l-1.5-1c-.5,.8-1,1.7-1.6,2.6l1.6,.9c.5-.9,1-1.7,1.5-2.5Z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M484,153.3l1.8,.2c0-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.3,3Z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M507.8,90.3l-1.1-1.4c-.8,.6-1.6,1.3-2.3,2.1l1.3,1.3c.7-.7,1.4-1.3,2.2-1.9Z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M503.6,94.4l-1.4-1.2c-.6,.8-1.3,1.6-1.9,2.4l1.5,1.1c.6-.8,1.2-1.6,1.8-2.3Z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M511.7,87.7l-.8-1.6c-.6,.3-1.1,.6-1.7,1l1,1.5c.5-.3,1-.6,1.6-.9Z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M487.6,138.5l-1.8-.3c0,.2,0,.4,0,.6h-1.1c0,1.1,.2,2.1,.2,3.1h1.8c0-.3,0-.4,0-.5h.5c.1-.9,.3-1.9,.4-2.9Z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M486.4,147.4c.1-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.4,3l1.8,.2Z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M489.8,126.8l-1.8-.4c-.2,1-.4,2-.6,3l1.8,.4c.2-1,.4-1.9,.6-2.9Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M497.3,104.3l-1.6-.8c-.4,.9-.9,1.8-1.3,2.8l1.6,.7c.4-.9,.8-1.8,1.3-2.7Z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M491.2,121l-1.7-.5c-.3,1-.5,2-.8,2.9l1.8,.4c.2-1,.5-1.9,.7-2.9Z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M488.6,132.6l-1.8-.3c-.2,1-.4,2-.5,3l1.8,.3c.2-1,.3-2,.5-2.9Z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M494.9,109.7l-1.7-.7c-.4,.9-.7,1.9-1.1,2.8l1.7,.6c.3-.9,.7-1.9,1.1-2.8Z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M492.9,115.3l-1.7-.6c-.3,1-.6,1.9-.9,2.9l1.7,.5c.3-1,.6-1.9,.9-2.8Z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M480.6,112.5l1.8-.4c-.2-1-.5-2-.7-2.9l-1.7,.5c.2,.9,.5,1.9,.7,2.9Z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M479.1,106.7l1.7-.5c-.3-1-.6-2-.9-2.9l-1.7,.5c.3,.9,.6,1.9,.9,2.8Z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M477.3,101l1.7-.6c-.4-1-.7-1.9-1.1-2.8l-1.7,.7c.3,.9,.7,1.8,1,2.8Z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M469.2,85.4l1.4-1.1c-1.3-1.6-2.2-2.3-2.2-2.3l-1.1,1.4s.8,.6,1.9,2Z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M475.2,95.5l1.6-.7c-.4-.9-.9-1.9-1.3-2.8l-1.6,.8c.4,.9,.9,1.8,1.3,2.7Z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M474.1,89.4c-.5-.9-1.1-1.8-1.6-2.6l-1.5,1c.5,.8,1,1.6,1.5,2.5l1.6-.9Z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M481.9,118.3l1.8-.3c-.2-1-.4-2-.6-3l-1.8,.4c.2,.9,.4,1.9,.6,2.9Z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M483.7,130.1l1.8-.2c-.1-1-.3-2-.4-3l-1.8,.2c.1,1,.3,2,.4,3Z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M484.4,136l1.8-.2c0-1-.2-2-.3-3l-1.8,.2c.1,1,.2,2,.3,3Z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M482.9,124.2l1.8-.3c-.2-1-.3-2-.5-3l-1.8,.3c.2,1,.3,1.9,.5,2.9Z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M464.1,114.8c-.7-.7-1.5-1.4-2.3-2l-1.1,1.4c.7,.6,1.5,1.2,2.2,1.9l1.2-1.3Z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M468.2,119.3c-.6-.8-1.3-1.6-2-2.3l-1.3,1.2c.6,.7,1.3,1.5,1.9,2.2l1.4-1.1Z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M439.1,107.9s1.1-.3,2.8-.3v-1.8c-2,0-3.2,.4-3.2,.4l.4,1.7Z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M453.9,108c-1-.4-1.9-.7-2.9-1l-.5,1.7c.9,.3,1.8,.6,2.7,1l.7-1.7Z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M444.8,107.6c1,0,1.9,.2,2.9,.4l.3-1.8c-1-.2-2.1-.3-3.1-.4v1.8Z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M480.9,146.6c-.3-1-.5-2-.8-2.9l-1.7,.5c.3,.9,.5,1.9,.8,2.9l1.7-.5Z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M479.2,140.8c-.3-1-.7-1.9-1-2.9l-1.7,.6c.3,.9,.7,1.8,1,2.8l1.7-.6Z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M483.6,158.4c-.2-1-.4-2-.6-3l-1.8,.4c.2,1,.4,1.9,.6,2.9l1.8-.3Z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M474.7,129.6c-.5-.9-.9-1.8-1.4-2.7l-1.6,.9c.5,.8,.9,1.7,1.4,2.6l1.6-.8Z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M477.1,135.1c-.4-1-.8-1.9-1.2-2.8l-1.6,.7c.4,.9,.8,1.8,1.2,2.7l1.7-.7Z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M482.4,152.5c-.2-1-.5-2-.7-2.9l-1.8,.4c.2,.9,.5,1.9,.7,2.9l1.8-.4Z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M468.6,122.8c.5,.8,1.1,1.6,1.6,2.5l1.5-.9c-.5-.9-1.1-1.7-1.7-2.5l-1.5,1Z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M555.4,179.3l-1.4-.2c0-.3,0-1.3,0-2.9h-1c0-.4,0-.7-.2-1l-1.8,.3c.2,1,.3,1.9,.5,2.9h.6c0,.5,0,.8,0,.8h1.4c-.1,.9-.2,1.5-.2,2l-1.4,.2c0,.5,.1,1,.2,1.5l1.8-.2c0-.2,0-.4,0-.6h1.2s0-1,.3-2.9Z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M557.8,167.7l-1.7-.5c-.3,1-.5,2-.8,2.9l1.8,.4c.2-.9,.5-1.9,.8-2.9Z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M564.5,151.2l-1.6-.9c-.5,.9-1,1.8-1.4,2.7l1.6,.8c.4-.9,.9-1.8,1.4-2.6Z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M559.6,162l-1.7-.6c-.4,1-.7,1.9-1,2.9l1.7,.5c.3-.9,.6-1.9,1-2.8Z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M561.8,156.5l-1.6-.7c-.4,.9-.8,1.9-1.2,2.8l1.7,.7c.4-.9,.7-1.8,1.2-2.7Z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M594.4,123.8l-.7-1.7c-.9,.4-1.9,.8-2.8,1.2l.8,1.6c.9-.4,1.8-.8,2.7-1.2Z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M589,126.3l-.9-1.6c-.9,.5-1.8,1-2.6,1.5l.9,1.5c.8-.5,1.7-1,2.6-1.5Z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M584,129.4l-1-1.5c-.8,.6-1.7,1.2-2.5,1.8l1.1,1.4c.8-.6,1.6-1.2,2.4-1.7Z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M567.5,146.1l-1.5-1c-.6,.9-1.1,1.7-1.6,2.6l1.5,.9c.5-.8,1-1.7,1.6-2.5Z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M575.8,133.5l1.2,1.3c.7-.7,1.5-1.3,2.2-1.9l-1.2-1.4c-.8,.6-1.5,1.3-2.3,2Z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M571.6,137.9l1.3,1.2c.7-.7,1.3-1.5,2-2.2l-1.3-1.3c-.7,.7-1.4,1.5-2.1,2.2Z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M567.8,142.6l1.5,1.1c.6-.8,1.2-1.6,1.8-2.3l-1.4-1.1c-.6,.8-1.3,1.6-1.9,2.4Z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M556.4,173.4l-1.8-.4c-.2,1.1-.4,2.1-.6,3l1.8,.3c.1-.9,.3-1.9,.5-2.9Z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M596.5,121l.6,1.7c.9-.3,1.9-.7,2.8-1l-.5-1.7c-1,.3-1.9,.6-2.9,1Z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M572.4,108.2l-1.4-1.2c-.6,.8-1.3,1.6-1.9,2.4l1.5,1.1c.6-.8,1.2-1.6,1.8-2.3Z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M552.8,167.2l1.8,.2c0-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.3,3Z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M556.4,152.4l-1.8-.3c0,.2,0,.4,0,.6h-1.1c0,1.1,.2,2.1,.2,3.1h1.8c0-.3,0-.4,0-.5h.5c.1-.9,.3-1.9,.4-2.9Z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M552.4,173.2h1.8c0-.8,.1-1.8,.2-2.9h-1.8c0,1-.1,2-.2,2.9Z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M569,113l-1.5-1c-.5,.8-1,1.7-1.6,2.6l1.6,.9c.5-.9,1-1.7,1.5-2.5Z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M576.6,104.2l-1.1-1.4c-.8,.6-1.6,1.3-2.3,2.1l1.3,1.3c.7-.7,1.4-1.3,2.2-1.9Z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M580.5,101.6l-.8-1.6c-.6,.3-1.1,.6-1.7,1l1,1.5c.5-.3,1-.6,1.6-.9Z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M555.2,161.3c.1-1,.2-2,.3-3l-1.8-.2c-.1,1-.2,2-.4,3l1.8,.2Z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M563.7,123.6l-1.7-.7c-.4,.9-.7,1.9-1.1,2.8l1.7,.6c.3-.9,.7-1.9,1.1-2.8Z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M561.7,129.2l-1.7-.6c-.3,1-.6,1.9-.9,2.9l1.7,.5c.3-1,.6-1.9,.9-2.8Z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M557.4,146.5l-1.8-.3c-.2,1-.4,2-.5,3l1.8,.3c.2-1,.3-2,.5-2.9Z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M566.1,118.1l-1.6-.8c-.4,.9-.9,1.8-1.3,2.8l1.6,.7c.4-.9,.8-1.8,1.3-2.7Z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M558.6,140.7l-1.8-.4c-.2,1-.4,2-.6,3l1.8,.4c.2-1,.4-1.9,.6-2.9Z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M560,134.9l-1.7-.5c-.3,1-.5,2-.8,2.9l1.8,.4c.2-1,.5-1.9,.7-2.9Z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M551.7,138.1l1.8-.3c-.2-1-.3-2-.5-3l-1.8,.3c.2,1,.3,1.9,.5,2.9Z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M552.5,144l1.8-.2c-.1-1-.3-2-.4-3l-1.8,.2c.1,1,.3,2,.4,3Z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M553.2,149.9l1.8-.2c0-1-.2-2-.3-3l-1.8,.2c.1,1,.2,2,.3,3Z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M549.5,126.4l1.8-.4c-.2-1-.5-2-.7-2.9l-1.7,.5c.2,.9,.5,1.9,.7,2.9Z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M550.7,132.2l1.8-.3c-.2-1-.4-2-.6-3l-1.8,.4c.2,.9,.4,1.9,.6,2.9Z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M546.2,114.9l1.7-.6c-.4-1-.7-1.9-1.1-2.8l-1.7,.7c.3,.9,.7,1.8,1,2.8Z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M544,109.4l1.6-.7c-.4-.9-.9-1.9-1.3-2.8l-1.6,.8c.4,.9,.9,1.8,1.3,2.7Z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M548,120.6l1.7-.5c-.3-1-.6-2-.9-2.9l-1.7,.5c.3,.9,.6,1.9,.9,2.8Z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M538,99.3l1.4-1.1c-1.3-1.6-2.2-2.3-2.2-2.3l-1.1,1.4s.8,.6,1.9,2Z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M542.9,103.3c-.5-.9-1.1-1.8-1.6-2.6l-1.5,1c.5,.8,1,1.6,1.5,2.5l1.6-.9Z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M513.6,121.5c1,0,1.9,.2,2.9,.4l.3-1.8c-1-.2-2.1-.3-3.1-.4v1.8Z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M519.3,122.6c.9,.3,1.8,.6,2.7,1l.7-1.7c-1-.4-1.9-.7-2.9-1l-.5,1.7Z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M524.7,124.8c.8,.5,1.7,1,2.5,1.5l1-1.5c-.9-.6-1.7-1.1-2.6-1.6l-.9,1.6Z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M549.8,160.5c-.3-1-.5-2-.8-2.9l-1.7,.5c.3,.9,.6,1.9,.8,2.9l1.7-.5Z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M548,154.7c-.3-1-.7-1.9-1-2.9l-1.7,.6c.3,.9,.7,1.8,1,2.8l1.7-.6Z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M551.2,166.4c-.2-1-.5-2-.7-2.9l-1.8,.4c.2,.9,.5,1.9,.7,2.9l1.8-.4Z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M552.4,172.3c-.2-1-.4-2-.6-3l-1.8,.4c.2,1,.4,1.9,.6,2.9l1.8-.3Z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M545.9,149c-.4-1-.8-1.9-1.2-2.8l-1.6,.7c.4,.9,.8,1.8,1.2,2.7l1.7-.7Z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M533.7,132.1c.6,.7,1.3,1.5,1.9,2.2l1.4-1.1c-.6-.8-1.3-1.6-2-2.3l-1.3,1.2Z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M529.5,128c.7,.6,1.5,1.2,2.2,1.9l1.2-1.3c-.7-.7-1.5-1.4-2.3-2l-1.1,1.4Z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M543.5,143.5c-.5-.9-.9-1.8-1.4-2.7l-1.6,.9c.5,.8,.9,1.7,1.4,2.6l1.6-.8Z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M537.4,136.7c.5,.8,1.1,1.6,1.6,2.5l1.5-.9c-.5-.9-1.1-1.7-1.7-2.5l-1.5,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPivotSymbol);
export default __webpack_public_path__ + "static/media/pivot-symbol.a2163e662a8b951a0886ec4f0f862fd5.svg";
export { ForwardRef as ReactComponent };